import { TransactionApi } from '../../infrastructure/api';
import { PdfGenerator } from '../../infrastructure/adapters';
import { ReceiptApiData } from '../../shared/types';

export interface PrintReceiptInput {
    supplierId: number | null;
    token: string | null;
    transactionId?: number;
    /** comprovante em texto de versões antigas do backend, usado se a busca completa falhar */
    fallbackReceiptText?: string;
    driverName?: string;
    driverRegistration?: string;
}

export class PrintReceiptUseCase {
    async execute(input: PrintReceiptInput): Promise<void> {
        const data = await this.loadReceipt(input);
        await PdfGenerator.generateReceipt(data);
    }

    private async loadReceipt(input: PrintReceiptInput): Promise<ReceiptApiData> {
        const { supplierId, token, transactionId, fallbackReceiptText, driverName, driverRegistration } = input;

        if (supplierId && token && transactionId) {
            try {
                return await TransactionApi.fetchReceipt(supplierId, transactionId, token);
            } catch (error) {
                if (!fallbackReceiptText) throw error;
                console.warn('Erro ao buscar comprovante completo, usando comprovante em texto:', error);
            }
        }

        if (fallbackReceiptText) {
            return PdfGenerator.fromReceiptText(fallbackReceiptText, driverName, driverRegistration);
        }

        throw new Error('Comprovante indisponível para esta venda');
    }
}
